import { render, staticRenderFns } from "./filter-date-created.vue?vue&type=template&id=6c1dd7fa"
import script from "./filter-date-created.vue?vue&type=script&lang=js"
export * from "./filter-date-created.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports